import * as React from 'react';

import "./icons/pi.png";
import "./icons/p.png";
import "./icons/s.png";
import "./icons/ho.png";
import "./icons/sigma.png";


const goalValues = [
	"pi",
	"p",
	"s",
	"ho",
	"sigma",
];

interface IGoalState {
	pushed: boolean;
	sigma: string;
	ho: string;
	p: string;
	s: string;
	pi: string;
}

export class Goal extends React.Component<{}, IGoalState> {
	constructor(props: Readonly<{}>) {
		super(props);

		this.state = {
			pushed: false,
			sigma: "",
			ho: "",
			p: "",
			s: "",
			pi: "",
		};

		const elem = document.getElementById('react-app');
		elem.addEventListener('set-goal', (e: CustomEvent) => this.setGoal(e.detail.goal), false);
	}

	public render() {
		if (goalValues.every(x => !this.state[x])) {
			return <div></div>
		}

		return <div className="goal">
			{goalValues.map((value, x) => {
				if (!this.state[value]) {
					return;
				}

				return <div className="goal-section" key={x}>
					<img className="goal-icon" src={"../../images/" + value + ".png"}></img>
					<div className="goal-text">x {this.state[value]}</div>
				</div>
			})}
		</div>
	}

	pushOver() {
		this.setState({ pushed: !this.state.pushed });
	}

	setGoal(state: IGoalState) {
		console.log(state);
		this.setState({
			sigma: state.sigma,
			ho: state.ho,
			p: state.p,
			s: state.s,
			pi: state.pi,
		});
	}
}